const th = {
    lan_key: 'th_TH',
    promotions: 'โปรโมชั่น',
    reserve: 'จอง',
    bookings: 'การจอง',
    free_trans: 'บริการรถรับส่งฟรี',
    my_booking: 'การจองของฉัน',
    upcoming: 'กำลังจะมาถึง',
    completed: 'เสร็จสิ้นแล้ว',
    cancelled: 'ยกเลิกแล้ว',

    confirm: 'ยืนยัน',
    depart_date: 'วันออกเดินทาง',
    depart_at: 'ออกเดินทางที่',
    return_at: 'กลับเวลา',
    first_name: 'ชื่อจริง',
    last_name: 'นามสกุล',
    contact_number: 'หมายเลขติดต่อ',
    email: 'อีเมล',
    num_of_people: 'จำนวนผู้โดยสาร',
    room_num: 'หมายเลขห้อง',
    detail: 'รายละเอียด',
    booking_id: 'รหัสการจอง',
    status: 'สถานะ',
    name: 'ชื่อ',
    hotel_name: 'ชื่อโรงแรม',
    date: 'วันที่',
    depart_time: 'เวลาออกเดินทาง',
    return_time: 'เวลากลับ',
    license: 'ใบอนุญาต',
    driver_phone: 'หมายเลขโทรศัพท์คนขับ',

    to_be_confirm: 'รอยืนยัน',
    confirmed: 'ยืนยันแล้ว',
    finished: 'เสร็จสิ้นแล้ว',
    success_order: 'สั่งซื้อเรียบร้อยแล้ว',
    thank_booking: 'ขอบคุณสำหรับการจองของคุณ โปรดเพลิดเพลินกับการเดินทางของคุณ',
    cancel_order: 'ยกเลิกการสั่งซื้อ',
    cancel_success: 'คุณได้ยกเลิกการสั่งซื้อเรียบร้อยแล้ว',
    book_detail: 'รายละเอียดการจอง',
    passport_num: 'หมายเลขหนังสือเดินทาง',
    period: 'ระยะเวลา',
    cancel: 'ยกเลิก',
    back_to_home: 'กลับสู่หน้าหลัก',

    wait_order_confirm: 'กำลังรอการยืนยันการสั่งซื้อ...',
    pls_wait_for: 'โปรดรอการยืนยันคำสั่งซื้อของคุณ',

    tips1: 'พนักงานของเราจะติดต่อคุณทางโทรศัพท์ก่อนการออกเดินทาง โปรดเปิดโทรศัพท์ให้เปิดเสียงริง เพื่อหากเราไม่สามารถติดต่อคุณได้ พนักงานขับรถอาจไม่มารับคุณ',
    tips2: 'โปรดนำหนังสือเดินทางของผู้โดยสารทั้งหมดมาด้วย',
    tips3: 'รับการยืนยันคำสั่งซื้อทางอีเมล หากคุณไม่ได้รับอีเมลจากเรา โปรดตรวจสอบที่หน้า "การจองของฉัน" หรือติดต่อเราออนไลน์',
    tips4: 'โปรดติดต่อเราผ่านการสนทนาออนไลน์หรือโทรติดต่อเราโดยตรงที่เคาน์เตอร์หน้าโรงแรม (เวลาเปิด: 09:00 - 18:00)',
    tips5: 'ข้อเสนอนี้รวมถึงบริการการขนส่งทั้งหมดฟรี',
    tips6: 'โปรดรอที่หน้าห้องโถงโรงแรมของคุณล่วงหน้า 10 นาที',
    tips7: 'Hotline บริการ: 094-594-8895',

    pls_sel_depart_date: 'กรุณาเลือกวันออกเดินทาง',
    pls_sel_depart_time: 'กรุณาเลือกเวลาออกเดินทาง',
    pls_sel_return_time: 'กรุณาเลือกเวลากลับ',

    pls_input_first_name: 'กรุณากรอกชื่อ',
    pls_input_last_name: 'กรุณากรอกนามสกุล',
    pls_input_contact_num: 'กรุณากรอกหมายเลขติดต่อ',
    pls_input_email: 'กรุณากรอกอีเมล',
    pls_input_room_num: 'กรุณากรอกหมายเลขห้อง',
    pls_input_people: 'กรุณากรอกจำนวนผู้โดยสาร',


    c_sun: 'Sun',
    c_mon: 'Mon',
    c_tue: 'Tue',
    c_wed: 'Wed',
    c_thu: 'Thu',
    c_fri: 'Fri',
    c_sat: 'Sat',

    wrong_msg: 'ที่อยู่ / เบอร์โทรศัพท์ / ข้อมูลไม่ถูกต้อง',
    time_not_avail: 'เวลาไม่พร้อมใช้งานสำหรับฉัน',
    change_excursion: 'ฉันได้เปลี่ยนแปลงการท่องเที่ยวของฉัน',
    change_mind: 'ฉันเพิ่งเปลี่ยนใจ',
    other: 'อื่น ๆ',
    pls_sel_a_cancel_reason: 'โปรดเลือกเหตุผลในการยกเลิก',
    sure_to_cancel_this_order: 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งนี้',
    input_u_reason: 'โปรดระบุเหตุผลการยกเลิกของคุณ (ตัวเลือก)',
    close: 'ปิด',

    product: 'ผลิตภัณฑ์',
    destination: 'ปลายทาง',
    hotel_address: 'ที่อยู่โรงแรม',
    transport: 'การขนส่ง',

    view: 'ดูข้อมูล',
    servicer: 'บริการลูกค้า',
    wechat: 'WeChat',
    play_guide: 'คำแนะนำการเล่น',
    pls_sel_product: 'โปรดเลือกผลิตภัณฑ์',
    round_trip: 'ไป-กลับ',
    no_need: 'ไม่จำเป็น',
    pls_input_hotel_name: 'โปรดป้อนชื่อโรงแรม',
    pls_input_hotel_address: 'โปรดป้อนที่อยู่โรงแรม',
    private_car: 'รถส่วนตัว',
    go_trip: 'ไป',
    return_trip: 'กลับ',
    pls_scan_code_to_known: 'โปรดสแกนโค้ดเพื่อเพิ่มบริการลูกค้าเพื่อติดตามสถานะการสั่งซื้อและข้อมูลผลิตภัณฑ์แบบเรียลไทม์',

    play_time: 'เวลาเล่น',

    if_need_traffic: 'หากคุณต้องการบริการรับส่ง โปรดติดต่อฝ่ายบริการลูกค้า',
    see_code_of_service: 'ดูโค้ด QR บริการลูกค้า',
    service_email: 'อีเมลฝ่ายบริการลูกค้า',

    more_info: 'ดูรายละเอียดเพิ่มเติม',
    customer_service: 'บริการลูกค้า',
    p_tips: 'มีผลทันที การจองผลิตภัณฑ์ใดๆ จะทำให้คุณมีสิทธิ์เข้าใช้กิจกรรมทางน้ำต่างๆ ที่ Marin Center ได้ฟรี.',
    cancel_apply_submit_success: 'ยกเลิกการส่งใบสมัครสำเร็จ',

    pls_sel_play_time: 'โปรดเลือกเวลาเล่น',

    from_price_currency: 'เริ่มต้นจาก {currency}{price} หยวน',
    pls_input_tel_no: 'กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ',
    no_pay_info: 'ไม่มีข้อมูลที่เกี่ยวข้องกับการชำระเงิน',

    adult: 'ผู้ใหญ่',
    children: 'เด็ก',
    old_man: 'ชายชรา',
    baby: 'เดกเดก',
    package: 'แพ็คเกจ',
    price: 'ราคา',
    use_date: 'ใช้วันที่',
    cer_no: 'หมายเลขใบรับรอง',
    customer_info: 'ข้อมูลผู้โดยสาร',
    payment: 'การชำระเงิน',
    quering_pay_status: 'กำลังค้นหาสถานะการชำระเงิน...',

    to_be_paid: 'จะต้องชำระ',
    to_be_verify: 'คำสั่งซื้อที่จะได้รับการยืนยัน',
    cancel_pending_confirm: 'ยกเลิกการยืนยันที่รอดำเนินการ',
    rejected: 'ถูกปฏิเสธ',
    fill_info: 'กรอกข้อมูล',
    book_sel: 'การเลือกการจอง',
    trip_info: 'ข้อมูลการเดินทาง',
    add_tourist: 'เพิ่มนักท่องเที่ยว',
    tourist: 'นักท่องเที่ยว',
    pls_input: 'กรุณาระบุ',
    pls_input_name: 'กรุณากรอกชื่อของคุณ',
    pls_cer_no: 'โปรดป้อนหมายเลขใบรับรอง',
    contacts: 'ติดต่อ',
    contact_tel: 'ติดต่อโทรศัพท์มือถือ',
    hotel_info: 'ข้อมูลโรงแรม',
    total_amount: 'จำนวนเงินทั้งหมด',
    in_payment: 'กำลังชำระเงิน',
    to_pay: 'ไปชำระเงิน',
    num_of_copies: 'จำนวนสำเนา',
    login: 'เข้าสู่ระบบ',
    login_by_email: 'อีเมลเข้าสู่ระบบ',
    pls_input_email: 'กรุณากรอกอีเมลของคุณ',
    password: 'รหัสผ่าน',
    pls_input_pwd: 'กรุณากรอกรหัสผ่าน',
    reg_user: 'ผู้ใช้ที่ลงทะเบียน',
    third_party_login: 'การเข้าสู่ระบบของบุคคลที่สาม',
    confirm_pwd: 'ยืนยันรหัสผ่าน',
    register: 'ลงทะเบียน',
    sel_pkg_date: 'เลือกวันที่ของแพ็คเกจ',
    sel_pkg: 'เลือกแพ็คเกจ',
    sel_date: 'เลือกวันที่',
    more: 'เพิ่มเติม',
    relate_itinerary: 'แผนการเดินทางที่เกี่ยวข้อง',
    img_n_text: 'รายละเอียดรูปภาพและข้อความ',
    cost_desc: 'คำอธิบายต้นทุน',
    cost_include: 'รวมค่าใช้จ่าย',
    cost_by_oneself: 'จ่ายเพื่อตัวคุณเอง',
    crow_desc: 'คำอธิบายฝูงชน',
    use_desc: 'ใช้คำแนะนำ',
    notice_desc: 'หมายเหตุ',
    cancel_rule: 'ยกเลิกกฎ',
    next_step: 'ขั้นตอนถัดไป',
    refund_anytime: 'คุณสามารถคืนเงินได้ตลอดเวลา',
    cant_refund: 'ไม่สามารถคืนเงินได้',
    years_old: 'หนึ่งปี',
    include: 'รวม',
    not_include: 'ไม่มี',
    over: 'เหนือ',
    under: 'ด้านล่าง',
    birth_day: 'วันเกิด',
    year: 'ปี',
    trip_date: 'วันที่เดินทาง',
    book_date: 'วันที่จอง',
    meter: 'เมตร',
    unlimited: 'ไม่จำกัด',
    age_group: 'กลุ่มอายุ',
    year_include: 'หนึ่งปี (รวม)',
    catering: 'การจัดเลี้ยง',
    shopping: 'ช้อปปิ้ง',
    traffic: 'การจราจร',
    gather: 'คอลเลกชัน',
    return_trip: 'กลับมา',
    play_act: 'เล่นกิจกรรม',
    end_trip: 'สิ้นสุดการเดินทาง',
    dining: 'อาหาร',
    place: 'สถานที่',
    no_need_ticket: 'ไม่ต้องใช้ตั๋ว',
    scenic_spots: 'จุดกิจกรรม',
    free_time: 'กิจกรรมฟรี',
    disband_in_place: 'ยุบกลุ่ม',
    disperse_on_return_trip: 'แยกย้ายกันไปเมื่อเดินทางกลับ',
    send_on_return_trip: 'เดินทางกลับและส่งกลับ',
    traffic_way: 'ทางจราจร',
    disband_place: 'สถานที่แยกย้าย',
    gather_place: 'สถานที่รวบรวม',
    pickup_to: 'ไปรับที่ประตู',
    biz_product: 'ผลิตภัณฑ์ทางธุรกิจ',
    go_there: 'ไป',
    go_back: 'กลับมา',
    logout: 'ออกจากระบบ',
    sure_to_logout: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ',
    create_success_pls_pay: 'สร้างคำสั่งซื้อเรียบร้อยแล้ว โปรดชำระเงินให้เสร็จสิ้น',

    monday_w: 'วันจันทร์',
    tuesday_w: 'วันอังคาร',
    wednsday_w: 'วันพุธ',
    thursday_w: 'วันพฤหัสบดี',
    friday_w: 'วันศุกร์',
    saturday_w: 'วันเสาร์',
    sunday_w: 'วันอาทิตย์',

    cul_age_standar: 'คำนวณอายุตาม {ageType} ตามอายุจริงของ {dateType}',
    can_n_book_lonely: '{man} ไม่สามารถจองได้เพียงคนเดียว',
    input_one_at_least: 'กรุณากรอกข้อมูลผู้โดยสารอย่างน้อยหนึ่งคน',
    t_remark: 'หมายเหตุ',
    pls_input_x_customer_info: 'กรุณากรอกข้อมูลผู้โดยสารจำนวน {num} คน',
    pls_sel_country: 'กรุณาเลือกประเทศ',
    birth_date: 'วันเกิด',
    t_sex: 'เพศ',
    cn_name: 'ชื่อภาษาจีน',
    en_name: 'ชื่อภาษาอังกฤษ',
    cn_en_name: 'ชื่อภาษาจีน/อังกฤษ',
    national_region: 'ประเทศ/ภูมิภาค',
    t_height: 'ส่วนสูง',
    t_male: 'ชาย',
    t_female: 'หญิง',
    pls_sel_date: 'กรุณาเลือกวันที่',
    t_quality: 'จำนวน',
    t_pay_remain_time: 'เวลาที่เหลือในการชำระเงิน: {minute} นาที {second} วินาที',
    t_no_relate_trip_info: 'ไม่มีข้อมูลการเดินทางที่เกี่ยวข้อง',
    t_disclaimer: 'ข้อสงวนสิทธิ์',
    t_min_book: 'สั่งซื้อขั้นต่ำ {minBook}',
    t_detail: 'รายละเอียด',
    t_fee_detail: 'รายละเอียดค่าใช้จ่าย',
    t_see_trip_info: 'ดูรายละเอียดการเดินทาง',
    t_need_change_contact_service: 'หากคุณต้องการเปลี่ยนแปลงคำสั่งซื้อ โปรดติดต่อฝ่ายบริการลูกค้า',

    t_surcharge: 'คิดค่าบริการ',
    t_pls_sel_buy_num: 'กรุณาเลือกจำนวนสินค้า',
    t_loging: 'เข้าสู่ระบบ',
    t_to_wx_auth: 'ได้รับอนุญาตจาก WeChat',
    t_all: 'ทั้งหมด',
    t_contact_service: 'ติดต่อฝ่ายบริการลูกค้า',

    t_send_email_tips: 'ใบยืนยันจะถูกส่งทางไปรษณีย์ไปยังกล่องจดหมายที่สอดคล้องกัน',
    t_clear_cache: "ล้างแคช",
    t_clear_success: "ล้างความสำเร็จ",
    t_sure_to_clear: 'คุณแน่ใจไหมว่าต้องการล้างแคช',
    t_no_stock: 'ไม่มีสต๊อก',
    t_refresh: 'รีเฟรช',
    t_filter: 'กรอง',

    t_collapse_all: "พับทั้งหมด",
    t_expand_all: "ขยายทั้งหมด",
    t_bind_account: 'ผูกหมายเลขบัญชี',
    t_between_num: '{from}{unit}-{to}{unit}',
    t_age: 'อายุ',
    t_sel_time: 'เลือกเวลา',
    t_unlimit_crowd: 'ฝูงชนไม่จำกัด',

    t_pending_Payment: 'รอดำเนินการชำระเงิน',
    t_unpaid: 'ยังไม่ได้ชำระ',
    t_paid: 'ชำระแล้ว',
    t_refunded: 'คืนเงินแล้ว',
    t_order_subtitle: 'ส่งคำสั่งซื้อแล้ว',
    t_await_confirm: 'กำลังรอการยืนยัน',
    t_order_confirmed: 'ยืนยันคำสั่งซื้อแล้ว',
    t_completed: 'เสร็จสมบูรณ์',
    t_cancel_pending_confirm: 'ยกเลิกเพื่อรอการยืนยัน',
    t_order_canceled: 'คำสั่งซื้อถูกยกเลิก',

    t_notice_title: 'แจ้งเตือน: เพื่อดูข้อมูลการจองของคุณ กรุณาเข้าสู่ระบบด้วยอีเมลที่ใช้ตอนทำการจอง',
    t_notice_content: 'รายละเอียด: หากไม่พบข้อมูลการจองในหน้านี้ กรุณาเข้าสู่ระบบด้วยอีเมลที่คุณใช้ตอนทำการจอง รหัสผ่านเริ่มต้นถูกส่งไปยังอีเมลที่คุณลงทะเบียนไว้แล้ว กรุณาตรวจสอบกล่องข้อความของคุณ',

    t_agree_1: 'ตกลงที่จะลงทะเบียนบัญชี "tour"',
    t_agree_2: 'เห็นด้วยกับข้อความข้างต้น',
    t_agree_3: 'ข้อมูลไม่สามารถเปลี่ยนแปลงได้หลังจากการส่ง',

    t_forget_pwd: 'ลืมรหัสผ่าน',
    t_email_of_receive: 'กล่องจดหมายสำหรับรับรหัสผ่านใหม่',
    t_reset_pwd_succes_tips: 'รหัสผ่านใหม่ถูกส่งไปยังกล่องจดหมายแล้ว โปรดตรวจสอบ',

    t_collapse: 'ยุบ',
    t_expand: 'ขยาย',

    what_is_included: 'รวมค่าใช้จ่าย',
    what_is_not_included: 'จ่ายเพื่อตัวคุณเอง',

}

export default th